import { Injectable } from '@angular/core';
import { FirebaseStorageService } from "app/services/firebase-storage.service";
import { FirebaseService } from "app/services/firebase.service";
import { FirebaseListObservable, FirebaseObjectObservable } from 'angularfire2/database';
import * as _ from 'underscore';
import { NotificationsService } from "angular2-notifications";

@Injectable()
export class ImageService {
    private db;
    private storageRootRef;
    images: FirebaseListObservable<Image[]>;
    name;
    url;
    size;
    sanitizeName;
    trueName;

    constructor(
        private firebaseService: FirebaseService,
        private firebaseStorageService: FirebaseStorageService,
        private notificationsService: NotificationsService
    ) {
        this.db = firebaseService.db;
        this.storageRootRef = firebaseStorageService.storageRootRef;
        this.loadImagesdb();
    }

    loadImagesdb() {
        window.dispatchEvent(new Event('loading'));
        this.images = this.db.list('/images') as FirebaseListObservable<Image[]>
        this.images.subscribe(data => {
            this.triggerDataChange();
        });
    }

    triggerDataChange() {
        window.dispatchEvent(new Event('data-loaded'));
    }

    getImages() {
        return this.images;
    }

    imageUpload(data) {
        var self = this;
        this.sanitizeName = data.selectedFile.name.toLowerCase().match(/\w+/g).join('-');
        var rawName = data.selectedFile.name.replace(/%/g, '');
        var check = this.checkDataexistence(this.sanitizeName, rawName);
        var metadata = {
            name: this.trueName,
        }
        var storageChildRef = this.storageRootRef.child('media/images/' + this.trueName);
        this.getImageSize(data.selectedFile).then((dimension: number[]) => {
            var task = storageChildRef.put(data.selectedFile, metadata);
            task.on('state_changed',
            
                function progress(snapshot) {
                    if (data.progress) {
                        data.progress.style.display = 'block';
                    }
                    var percentage = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    if (data.uploader) {
                        data.uploader.style.width = percentage + '%';
                    }
                },

                function error(err) {
                    console.log(err.message_);
                },

                function complete() {
                    if (data.closeBtn) {
                        for (var i in data.closeBtn) {
                            if (data.closeBtn.hasOwnProperty(i)) {
                                data.closeBtn[i].style.display = 'block';
                            }
                        }
                    }
                    if (data.modalTitle) {
                        data.modalTitle.innerHTML = 'Upload Complete';
                    }
                    storageChildRef.getMetadata().then(function (metadata) {
                        console.log(metadata);
                        var image = new Image();
                        image.$key = metadata.name.toLowerCase().match(/\w+/g).join('-');
                        image.name = metadata.name;
                        image.url = metadata.downloadURLs;
                        image.size = metadata.size;
                        image.fullpath = metadata.fullPath;
                        image.contentType = metadata.contentType;
                        image.dimension = dimension;
                        self.addImage(image);
                    });
                    if (data.progress) {
                        data.progress.style.display = 'none';
                    }
                    self.notificationsService.success('Uploaded', 'Image uploaded')
                    if (data.file_name_element) {
                        data.file_name_element.innerHTML = '';
                    }
                }
            );
        });
    }

    addImage(image) {
        if (image.$key) {
            var img_ref = this.db.object('/images/' + image.$key) as FirebaseObjectObservable<Document>

            delete image.$key;
            return img_ref.set(image)
        }
    }

    checkDataexistence(sanitizeName, rawName) {
        var self = this;
        var doc_ref = this.db.object('/images/' + sanitizeName)
        doc_ref.$ref.transaction(function (currentData) {
            if (currentData === null) {
                self.trueName = rawName;
            } else {
                self.trueName = self.nameplus(rawName);
                sanitizeName = self.trueName.toLowerCase().match(/\w+/g).join('-');
                self.checkDataexistence(sanitizeName, self.trueName)
                console.log('5: ' + self.trueName)
            }
        });
    }

    nameplus(name) {
        var ext = name.match(/\.\w{0,4}$/) ? name.match(/\.\w{0,4}$/)[0] : '';
        name = name.replace(/\.\w{0,4}$/, '');
        name = name.replace(/\-\d+$/, '') + '-' + (name.match(/\-\d+$/) ? (parseInt(name.match(/\d+$/)[0]) + 1) : 2);
        console.log('1: ' + name)
        console.log('4: ' + ext)
        return name + ext;
    }

    public getImageSize(file: File) {
        var promise = new Promise((resolve, reject) => {
            var image = document.createElement('img');
            image.onload = () => {
                resolve([image.width, image.height]);
            }
            image.src = URL.createObjectURL(file);

            image.remove();
        });

        return promise;
    }

    getImage(name) {
        var storgaeChildRef = this.storageRootRef.child('media/images');
        return storgaeChildRef;
    }

    deleteImage(name, key) {
        var self = this;
        var fileRef = this.firebaseStorageService.storageRootRef.child('media/images/' + name);
        fileRef.delete().then(function () {
            var result = self.images.remove(key);
            self.notificationsService.error('Deleted', 'Image deleted')
            return result;
        }).catch(function (error) {
            console.log('Hayoloh, ada error. Error: ' + error.code_ + '. Message: ' + error.message_);
        });
    }
}

export class Image {
    $key?: string;
    name?: string = '';
    url?: string[];
    size?: string = '';
    fullpath?: string = '';
    contentType?: string = '';
    dimension?: number[];

    created_at?: number;
    updated_at?: number;

    constructor() {
        var now = new Date();
        this.created_at = now.getTime();
        this.updated_at = now.getTime();
    }
}



// WEBPACK FOOTER //
// D:/www/kh_indesso_web/src/app/services/image.service.ts